export default "__VITE_ASSET__LP8lwztz__"